import { Question } from "../../../components/Question/Question";

export const QuestionPage = () => {
  return <Question />;
};
